export * from './TextDeprecated';
